//====================================================
//  Function: Category Create
//====================================================
var categoryGroup = $('.js-category-group')
var labelsGroup = $('.js-labels-group')

function componentCategoryCreate() {
  if ($('.js-category-group').length) {
    categoryGroup = $('.js-category-group')

    $('.js-select-option').change(function () {
      var checkbox = $(this)
      // var checkboxValue = checkbox.val()
      // var checkboxCode = checkbox.closest('.js-select-item').data('code')
      $('div').removeClass('is-clicked')
      $('.code-box__item').removeClass('is-clicked')
      // clearTimeout(myTimeoutCode);
      addToCategoryResultCode()
      rebuildTopCategoryResult()
    })

    $(document).on(
      'keyup',
      '.js-select-input, .js-select-input-main, .js-select-input-another, .js-category-input',
      function () {
        addToCategoryResultCode()
        rebuildTopCategoryResult()
      },
    )

    $(document).on(
      'change',
      '.js-block-item-css .js-select-input',
      function () {
        addToCategoryResultCode()
        rebuildTopCategoryResult()
      },
    )

    $(document).on('click', '.js-label-add', function () {
      addNewCategory()
      addToCategoryResultCode()
      rebuildTopCategoryResult()
    })

    $(document).on('click', '.js-label-remove', function () {
      if ($('.js-label-item').length > 1) {
        $(this).closest('.js-label-item').remove()
        rebuildTopCategoryResult()
      }
    })
  }
}

function addToCategoryResultCode() {
  var arrayResultCategory = []
  var arrayResultCategoryCSS = []
  var arrayResultCategoryItems = []
  var arrayResultSideCategory = []
  var arrayResultSubcategoryCategory = []
  var mainItem = false
  var anotherItem = true

  var index = $('.js-select-item')
  index.find('.js-block-item').each(function () {
    var item = $(this)
    var blockItemCSS = item.hasClass('js-block-item-css')
    if (item.data('comment') !== undefined) {
      if (item.data('comment').length) {
        if (blockItemCSS) {
          arrayResultCategoryCSS.push(
            "<div class='code__comment'>/* " +
              item.data('comment') +
              '*/</div>',
          )
        } else {
          arrayResultCategory.push(
            "<div class='code__comment'>// " + item.data('comment') + '</div>',
          )
        }
      }
    }

    if (item.find('.js-tab-list-item[data-id="tab-menu"].is-active').length) {
      item.find('.js-select-input-another').each(function () {
        input = $(this)
        if (input.val().length > 0) {
          // if ($('.js-select-input-main').val().length > 0) {
          //   $('.js-select-input-main').val('')
          // }

          // var templateBoxItem = `
          // 	<div class="code-box__item">
          // 	<strong>var <span class="js-result-type">topCategoryMenuItem</span> = <span class="js-result-value txt-green">${input.val()};</span></strong></div>
          // `
          var inputValue = input.val()

          arrayResultCategoryItems.push('"' + inputValue + '"')
          // anotherItem = true
        } else {
          // anotherItem = false
        }
      })
    } else {
      if (anotherItem) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">topCategoryAddonMenuItemCustom</span> = <span class="js-result-value txt-green">true;</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        arrayResultSideCategory.push(templateBoxItem)
        arrayResultSubcategoryCategory.push(templateBoxItem)

        labelsGroup.find('.js-label-item').each(function () {
          input = $(this)
          var categoryItemName = input.find('.js-label-input-name').val()
          var categoryItemSrc = input.find('.js-label-input-src').val()
          var categoryItemLink = input.find('.js-label-input-link').val()
          if (
            categoryItemName.length > 0 &&
            categoryItemSrc.length > 0 &&
            categoryItemLink.length > 0
          ) {
            arrayResultCategoryItems.push(`
							{name:"${categoryItemName}", image:"${categoryItemSrc}", url:"${categoryItemLink}"}
						`)
          }
        })
      }
    }

    // var checkInputAnother = checkAnother()

    if (!anotherItem) {
      // if ($('.js-select-input-main').val().length > 0) {
      //   var inputValue = $('.js-select-input-main').val()
      //   var templateBoxItem = `
      // 		<div class="code-box__item">
      // 		<strong>var <span class="js-result-type">topCategoryMenuItem</span> = <span class="js-result-value txt-green">${inputValue};</span></strong></div>
      // 	`
      //   arrayResultCategory.push(templateBoxItem)
      // }
    } else {
      if (arrayResultCategoryItems.join().length > 0) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">topCategoryAddonMenuItem</span> = <span class="js-result-value txt-green">[${arrayResultCategoryItems.join()}];</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        arrayResultSideCategory.push(templateBoxItem)
        arrayResultSubcategoryCategory.push(templateBoxItem)
        anotherItem = false
      }
    }

    item.find('.js-select-input').each(function () {
      var input = $(this)
      var inputParent = input.closest('.js-stats')
      var inputValue = input.val()
      var inputCode = inputParent.data('code')
      var inputQuotes = inputParent.data('quotes')
      var inputPX = inputParent.data('px')
      var inputType = inputParent.data('type')

      if (blockItemCSS) {
        inputValue = '' + inputValue + ''
      } else {
        if (inputQuotes == true) {
          inputValue = '"' + inputValue + '"'
        }

        if (inputPX == true) {
          inputValue = inputValue + 'px'
        }

        if (inputType == 'number') {
          inputValue = parseInt(inputValue)
        } else {
          inputValue = '"' + inputValue + '"'
        }
      }

      // var templateBoxItem = `
      // 		<div class="code-box__item">
      // 		<strong>var <span class="js-result-type">${inputCode}</span> = <span class="js-result-value txt-green">${inputValue};</span></strong></div>
      // `
      if (blockItemCSS) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>--<span class="js-result-type">${inputCode}</span>: <span class="js-result-value txt-green">${inputValue};</span></strong></div>
				`
        arrayResultCategoryCSS.push(templateBoxItem)
        inputParent
          .find('.js-label-value')
          .html('--' + inputCode + ' = <span> ' + inputValue + '</span>')
      } else {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">${inputCode}</span> = <span class="js-result-value txt-green">${inputValue};</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        arrayResultSideCategory.push(templateBoxItem)
        inputParent
          .find('.js-label-value')
          .html('var ' + inputCode + ' = <span> ' + inputValue + '</span>')
      }
    })

    item.find('.js-stats-checkbox').each(function () {
      var element = $(this)
      var checkedCheckbox = element.find('.js-select-option')
      var checkboxValue = checkedCheckbox.val()
      var clickedClass = ''
      var checkboxCode = element.data('code')
      var checkboxQuotes = element.data('quotes')

      if (checkedCheckbox.is(':checked')) {
        checkboxValue = true
      } else {
        checkboxValue = false
      }

      if (checkboxQuotes == true) {
        checkboxValue = '"' + checkboxValue + '"'
      }

      if (element.hasClass('is-clicked')) {
        clickedClass = 'is-clicked'
      }

      // if (checkboxValue === 'false' || checkboxValue === '"left"') {
      //   return false
      // }

      var templateBoxItem = `
			<div class="code-box__item ${clickedClass}">
			<strong>var <span class="js-result-type">${checkboxCode}</span> = <span class="js-result-value txt-green">${checkboxValue};</span></strong></div>
			`
      arrayResultCategory.push(templateBoxItem)
      arrayResultSideCategory.push(templateBoxItem)
      element
        .find('.js-label-value')
        .html('var ' + checkboxCode + ' = <span> ' + checkboxValue + '</span>')
    })

    if (item.hasClass('line-break')) {
      arrayResultCategory.push('<br>')
      // arrayResultSide.push('<br>')
    }
  })

  $('.js-code-result').empty()
  $('.js-code-result--side').empty()
  $('.js-code-result--subcategory').empty()
  $('.js-code-result--css').empty()
  $('.js-code-result').append(arrayResultCategory)
  $('.js-code-result--subcategory').append(arrayResultSubcategoryCategory)
  $('.js-code-result--side').append(arrayResultSideCategory)
  $('.js-code-result--css').append(arrayResultCategoryCSS)
}

var myTopCategorySwiper
var myTopCategorySwiperSide
var oldStructure = $('.dashboard-box-mobile-bg .js-top-category-addon').html()
var oldStructureSide = $('.js-top-category-addon-side').html()
var topCategoryAddonSliderAutoplay,
  topCategoryAddonSliderAutoplayTime,
  topCategoryAddonSliderMenuItemCount,
  topCategoryAddonSliderMenuItemCountMobile,
  topCategoryAddonSliderGutter

function rebuildTopCategoryResult() {
  var topCategoryBlock = $('.js-top-category-addon')
  var topCategoryAddonSectionTitle = $('#category_title').val()
  var topCategoryMenuItemCount = $('#category_count_desktop').val()
  var topCategoryAddonMenuItemCountMobile = $('#category_count_mobile').val()
  var topCategoryAddonMenuItemColumns = $(
    '#category_count_columns_desktop',
  ).val()
  var topCategoryAddonMenuItemColumnsMobile = $(
    '#category_count_columns_mobile',
  ).val()

  var topCategoryAddonSlider = $('#category_slider').is(':checked')
  var topCategoryAddonSliderStyle1 = $('#category_slider_style_1').is(
    ':checked',
  )
  topCategoryAddonSliderAutoplay = $('#category_slider_autoplay').is(':checked')
  topCategoryAddonSliderAutoplayTime = $('#category_slider_autoplay_time').val()
  topCategoryAddonSliderMenuItemCount = $(
    '#category_slider_count_desktop',
  ).val()
  topCategoryAddonSliderMenuItemCountMobile = $(
    '#category_slider_count_mobile',
  ).val()
  topCategoryAddonSliderGutter = parseInt($('#category_slider_gutter').val())
  var topCategoryAddonSliderArrowsBottom = $(
    '#category_slider_arrows_bottom',
  ).is(':checked')

  var topCategoryAddonMenuShort = $('#category_menu_short').is(':checked')
  var topCategoryAddonMenuMore = $('#category_menu_more').is(':checked')
  var topCategoryAddonBorder = $('#category_border').is(':checked')
  var topCategoryAddonBorderRadius = $('#category_border_radius').is(':checked')
  var topCategoryAddonBoxShadow = $('#category_box_shadow').is(':checked')
  var topCategoryAddonMenuStyleGrayBg = $('#category_menu_style_gray_bg').is(
    ':checked',
  )
  var topCategoryAddonMenuStyleRow = $('#category_menu_style_row').is(
    ':checked',
  )
  var topCategoryAddonItemsShortHeight = $(
    '#category_menu_style_short_height',
  ).is(':checked')

  // CSS
  let root = document.documentElement

  root.style.setProperty(
    '--border-radius-top-category',
    $('#category_design_border_radius_top_category').val() + 'px',
  )

  root.style.setProperty(
    '--color-top-category-black',
    $('#category_design_color_top_category-black').val(),
  )

  root.style.setProperty(
    '--color-top-category-black-hover',
    $('#category_design_color_top_category-black-hover').val(),
  )

  root.style.setProperty(
    '--color-top-category-gray',
    $('#category_design_color_top_category-gray').val(),
  )

  root.style.setProperty(
    '--border-color-top-category',
    $('#category_design_color_top_category_border').val(),
  )

  root.style.setProperty(
    '--background-color-menu-style-1-top-category',
    $('#category_design_color_top_category_bg_color').val(),
  )

  root.style.setProperty(
    '--background-color-arrow-top-category',
    $('#background-color-arrow-top-category').val(),
  )

  root.style.setProperty(
    '--background-color-arrow-top-category-hover',
    $('#background-color-arrow-top-category-hover').val(),
  )

  root.style.setProperty(
    '--background-color-slider-style-1-top-category',
    $('#background-color-slider-style-1-top-category').val(),
  )

  root.style.setProperty(
    '--background-color-slider-style-1-top-category-hover',
    $('#background-color-slider-style-1-top-category-hover').val(),
  )

  root.style.setProperty(
    '--color-slider-style-1-top-category',
    $('#color-slider-style-1-top-category').val(),
  )

  root.style.setProperty(
    '--color-slider-style-1-top-category-hover',
    $('#color-slider-style-1-top-category-hover').val(),
  )

  $('.h4.homepage-group-title').text(topCategoryAddonSectionTitle)

  topCategoryBlock.removeClass(
    'top-category-addon-1 top-category-addon-2 top-category-addon-3 top-category-addon-4 top-category-addon-5 top-category-addon-6 top-category-addon-7 top-category-addon-8 top-category-addon-9 top-category-addon-10 top-category-addon-11 top-category-addon-12',
  )
  topCategoryBlock.removeClass(
    'top-category-addon-mobile-1 top-category-addon-mobile-2 top-category-addon-mobile-3 top-category-addon-mobile-4 top-category-addon-mobile-5 top-category-addon-mobile-6 top-category-addon-mobile-7 top-category-addon-mobile-8 top-category-addon-mobile-9 top-category-addon-mobile-10 top-category-addon-mobile-11 top-category-addon-mobile-12',
  )
  topCategoryBlock.removeClass(
    'top-category-addon-columns-1 top-category-addon-columns-2 top-category-addon-columns-3 top-category-addon-columns-4 top-category-addon-columns-5 top-category-addon-columns-6 top-category-addon-columns-7 top-category-addon-columns-8 top-category-addon-columns-9 top-category-addon-columns-10 top-category-addon-columns-11 top-category-addon-columns-12',
  )
  topCategoryBlock.removeClass(
    'top-category-addon-columns-mobile-1 top-category-addon-columns-mobile-2 top-category-addon-columns-mobile-3 top-category-addon-columns-mobile-4 top-category-addon-columns-mobile-5 top-category-addon-columns-mobile-6 top-category-addon-columns-mobile-7 top-category-addon-columns-mobile-8 top-category-addon-columns-mobile-9 top-category-addon-columns-mobile-10 top-category-addon-columns-mobile-11 top-category-addon-columns-mobile-12',
  )

  topCategoryBlock.addClass('top-category-addon-' + topCategoryMenuItemCount)
  topCategoryBlock.addClass(
    'top-category-addon-mobile-' + topCategoryAddonMenuItemCountMobile,
  )
  topCategoryBlock.addClass(
    'top-category-addon-columns-' + topCategoryAddonMenuItemColumns,
  )
  topCategoryBlock.addClass(
    'top-category-addon-columns-mobile-' +
      topCategoryAddonMenuItemColumnsMobile,
  )

  if (!topCategoryAddonMenuMore) {
    topCategoryBlock.addClass('no-more-link')
  } else {
    topCategoryBlock.removeClass('no-more-link')
  }

  if (topCategoryAddonMenuShort) {
    topCategoryBlock.addClass('no-submenu no-more-link')
  } else {
    topCategoryBlock.removeClass('no-submenu')
  }

  if (topCategoryAddonBorder) {
    topCategoryBlock.addClass('is-border')
  } else {
    topCategoryBlock.removeClass('is-border')
  }

  if (topCategoryAddonBorderRadius) {
    topCategoryBlock.addClass('is-border-radius')
  } else {
    topCategoryBlock.removeClass('is-border-radius')
  }

  if (topCategoryAddonBoxShadow) {
    topCategoryBlock.addClass('is-box-shadow')
  } else {
    topCategoryBlock.removeClass('is-box-shadow')
  }

  if (topCategoryAddonItemsShortHeight) {
    topCategoryBlock.addClass('is-style-short-height')
  } else {
    topCategoryBlock.removeClass('is-style-short-height')
  }

  if (topCategoryAddonMenuStyleRow) {
    topCategoryBlock.addClass('is-menu-style-row')
  } else {
    topCategoryBlock.removeClass('is-menu-style-row')
  }

  if (topCategoryAddonMenuStyleGrayBg) {
    topCategoryBlock.addClass('is-menu-style-gray-bg')
  } else {
    topCategoryBlock.removeClass('is-menu-style-gray-bg')
  }

  if (topCategoryAddonSlider) {
    if ($('.swiper-wrapper').length) {
      myTopCategorySwiper.destroy(true, true)
      myTopCategorySwiperSide.destroy(true, true)
      $('.dashboard-box-mobile-bg .js-top-category-addon').html(oldStructure)
      $('.js-top-category-addon-side').html(oldStructureSide)
    }

    $('.js-top-category-addon').addClass('is-slider')
    if (topCategoryAddonSliderStyle1) {
      $('.js-top-category-addon').addClass('is-slider-style-1')
      $('.js-top-category-addon .menu-level-2 > li').each(function () {
        var link = $(this).find('.top-category-text-block > div > a')
        link.addClass('menu-content-title')
        link = $(this).find('.top-category-text-block > div > a')
        link.insertBefore($(this).find('.top-category-text-block'))
      })
      if ($(window).width() > bpSmall) {
        topCategoryAddonSliderGutter = 0
      }
    } else {
      $('.js-top-category-addon').removeClass('is-slider-style-1')
    }
    if (topCategoryAddonSliderArrowsBottom) {
      $('.js-top-category-addon').addClass('is-slider-arrows-bottom')
    } else {
      $('.js-top-category-addon').removeClass('is-slider-arrows-bottom')
    }

    createSliderFromTopCategory()
    createSliderFromTopCategorySide()

    $(window).trigger('resize')
  } else {
    if ($('.swiper-wrapper').length) {
      $('.js-top-category-addon').removeClass('is-slider')
      $('.js-top-category-addon').removeClass('is-slider-style-1')
      myTopCategorySwiper.destroy(true, true)
      myTopCategorySwiperSide.destroy(true, true)

      $('.dashboard-box-mobile-bg .js-top-category-addon').html(oldStructure)
      $('.js-top-category-addon-side').html(oldStructureSide)
    }
  }
}

function createSliderFromTopCategory() {
  var topCategoryAddon = $('.dashboard-box-mobile-bg .js-top-category-addon')
  var topCategoryMenuLevel2 = topCategoryAddon.find('.menu-level-2')
  var topCategorySlide = topCategoryMenuLevel2.find('> li')
  topCategorySlide.wrap('<div class="swiper-slide"></div>')
  topCategoryMenuLevel2.wrapInner(
    '<div class="swiper-container js-slider-top-category"></div>',
  )
  topCategoryMenuLevel2
    .find('.swiper-container')
    .wrapInner('<div class="swiper-wrapper"></div>')
  topCategoryMenuLevel2.wrapInner(
    '<div class="js-slider-group slider-group-top-category"></div>',
  )

  var arrowTemplate =
    '<div class="swiper-arrow swiper-arrow-next js-swiper-arrow-next">' +
    '<div class="swiper-arrow-content">' +
    '<span class="icon-svg icon-chevron-right"></span>' +
    '</div>' +
    '</div>' +
    '<div class="swiper-arrow swiper-arrow-prev js-swiper-arrow-prev">' +
    '<div class="swiper-arrow-content">' +
    '<span class="icon-svg icon-chevron-left"></span>' +
    '</div>' +
    '</div>'
  topCategoryMenuLevel2.find('.slider-group-top-category').append(arrowTemplate)

  initTopCategoryAddonSlider()
}

function initTopCategoryAddonSlider() {
  if ($('.js-slider-top-category').length) {
    $('.js-slider-top-category').each(function () {
      var inst = $(this),
        swiperBlock = inst.closest('.js-slider-group'),
        swiperBlockSide = swiperBlock.closest('.side-panel--settings'),
        swiperArrowPrev = swiperBlock.find('.js-swiper-arrow-prev'),
        swiperArrowNext = swiperBlock.find('.js-swiper-arrow-next'),
        topCategoryLength = swiperBlock.find('.swiper-wrapper > li').length,
        productsLooping

      if (topCategoryAddonSliderAutoplay) {
        var isAutoplay = {
          delay: topCategoryAddonSliderAutoplayTime,
          disableOnInteraction: true,
        }
      } else {
        var isAutoplay = false
      }

      if (topCategoryAddonSliderMenuItemCount) {
        categoriesSlides = topCategoryAddonSliderMenuItemCount
      }
      if (swiperBlockSide.length > 0) {
        var topCategoryBreakpoints = {
          200: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            //loopedSlides: topCategoryAddonSliderMenuItemCountMobile,
          },
          480: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            //loopedSlides: 3,
          },
          771: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            //loopedSlides: 3,
          },
          992: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            //loopedSlides: categoriesSlides - 1,
          },
          1200: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            //loopedSlides: categoriesSlides - 1,
          },
          1440: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            //loopedSlides: categoriesSlides,
          },
        }
      } else {
        var topCategoryBreakpoints = {
          200: {
            slidesPerView: topCategoryAddonSliderMenuItemCountMobile,
            slidesPerGroup: topCategoryAddonSliderMenuItemCountMobile,
            //loopedSlides: topCategoryAddonSliderMenuItemCountMobile,
          },
          480: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            //loopedSlides: 3,
          },
          771: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            //loopedSlides: 3,
          },
          992: {
            slidesPerView: categoriesSlides - 1,
            slidesPerGroup: categoriesSlides - 1,
            //loopedSlides: categoriesSlides - 1,
          },
          1200: {
            slidesPerView: categoriesSlides - 1,
            slidesPerGroup: 2,
            //loopedSlides: categoriesSlides - 1,
          },
          1440: {
            slidesPerView: categoriesSlides,
            slidesPerGroup: 2,
            //loopedSlides: categoriesSlides,
          },
        }
      }

      myTopCategorySwiper = new Swiper(inst, {
        spaceBetween: topCategoryAddonSliderGutter,
        lazy: true,
        // loop: topCategoryAddonSliderLoop,
        speed: 600,
        autoplay: isAutoplay,
        navigation: {
          nextEl: swiperArrowNext,
          prevEl: swiperArrowPrev,
        },
        breakpoints: topCategoryBreakpoints,
      })
    })
  }
}

function createSliderFromTopCategorySide() {
  var topCategoryAddon = $('.js-top-category-addon-side')
  var topCategoryMenuLevel2 = topCategoryAddon.find('.menu-level-2')
  var topCategorySlide = topCategoryMenuLevel2.find('> li')
  topCategorySlide.wrap('<div class="swiper-slide"></div>')
  topCategoryMenuLevel2.wrapInner(
    '<div class="swiper-container js-slider-top-category-side"></div>',
  )
  topCategoryMenuLevel2
    .find('.swiper-container')
    .wrapInner('<div class="swiper-wrapper"></div>')
  topCategoryMenuLevel2.wrapInner(
    '<div class="js-slider-group slider-group-top-category"></div>',
  )

  var arrowTemplate =
    '<div class="swiper-arrow swiper-arrow-next js-swiper-arrow-next">' +
    '<div class="swiper-arrow-content">' +
    '<span class="icon-svg icon-chevron-right"></span>' +
    '</div>' +
    '</div>' +
    '<div class="swiper-arrow swiper-arrow-prev js-swiper-arrow-prev">' +
    '<div class="swiper-arrow-content">' +
    '<span class="icon-svg icon-chevron-left"></span>' +
    '</div>' +
    '</div>'
  topCategoryMenuLevel2.find('.slider-group-top-category').append(arrowTemplate)

  initTopCategoryAddonSliderSide()
}

function initTopCategoryAddonSliderSide() {
  if ($('.js-slider-top-category-side').length) {
    $('.js-slider-top-category-side').each(function () {
      var inst = $(this),
        swiperBlock = inst.closest('.js-slider-group'),
        swiperArrowPrev = swiperBlock.find('.js-swiper-arrow-prev'),
        swiperArrowNext = swiperBlock.find('.js-swiper-arrow-next'),
        topCategoryLength = swiperBlock.find('.swiper-wrapper > li').length,
        productsLooping

      if (topCategoryAddonSliderAutoplay) {
        var isAutoplay = {
          delay: topCategoryAddonSliderAutoplayTime,
          disableOnInteraction: true,
        }
      } else {
        var isAutoplay = false
      }

      if (topCategoryAddonSliderMenuItemCount) {
        categoriesSlides = topCategoryAddonSliderMenuItemCount
      }

      myTopCategorySwiperSide = new Swiper(inst, {
        spaceBetween: topCategoryAddonSliderGutter,
        lazy: true,
        loop: false,
        slidesPerView: 1,
        // loop: topCategoryAddonSliderLoop,
        speed: 600,
        autoplay: isAutoplay,
        navigation: {
          nextEl: swiperArrowNext,
          prevEl: swiperArrowPrev,
        },
      })
    })
  }
}

// Change color picker
$('.picker-color__item').each(function () {
  var input = $(this)
  var inputColorBlock = input.find('.picker-color__input')
  var inputColor = inputColorBlock.find('input')
  var inputNumber = input.find('.js-select-input')
  var inputName = inputColor.attr('name')
  var inputValue
  inputColor.on('input', function (e) {
    inputValue = e.target.value
    inputNumber.val('#' + e.target.value.substring(1))
  })
  inputColor.change(function (e) {
    inputValue = e.target.value
    inputNumber.val('#' + e.target.value.substring(1))
    inputNumber.trigger('change')
  })

  inputNumber.keyup(function (e) {
    inputValue = e.target.value
    inputColor.val('#' + inputValue)
    inputColor.trigger('change')
  })
})

function addNewCategory() {
  counterLabel++
  var newLabelTemplate = `
	<div class="labels-group__item js-label-item" data-id="${counterLabel}">
			<div class="labels-group__content">
				<div class="h--margin-0 margin-bottom-1 margin-bottom-md-1 margin-top-1 h--font-primary-semibold">
					<h2 class="epsilon">Podkategória</h2>
				</div>
				<div class="row gutter-10 margin-bottom-06 align-items-center">
					<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
						<label class="form__label form__label--classic" for="label_${counterLabel}_name">Názov kategórie</label>
					</div>
					<div class="col-12 col-sm-7 col-xl-8">
						<div class="label__input">
							<input class="form__input form__input--small form__input--outline js-category-input js-label-input-name" type="text" id="label_${counterLabel}_name" name="label_${counterLabel}_name" value="iPhone">
						</div>
					</div>
				</div>
				<div class="row gutter-10 margin-bottom-06 align-items-center">
					<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
						<label class="form__label form__label--classic" for="label_${counterLabel}_src">URL adresa na obrázok</label>
					</div>
					<div class="col-12 col-sm-7 col-xl-8">
						<div class="label__input">
							<input class="form__input form__input--small form__input--outline js-category-input js-label-input-src" type="text" id="label_${counterLabel}_src" name="label_${counterLabel}_src" value="/user/documents/upload/logo/apple.png">
						</div>
					</div>
				</div>
				<div class="row gutter-10 margin-bottom-06 align-items-center">
					<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
						<label class="form__label form__label--classic" for="label_${counterLabel}_link">URL adresa kategórie</label>
					</div>
					<div class="col-12 col-sm-7 col-xl-8">
						<div class="label__input">
							<input class="form__input form__input--small form__input--outline js-category-input js-label-input-link" type="text" id="label_${counterLabel}_link" name="label_${counterLabel}_link" value="iphone">
						</div>
					</div>
				</div>
				<div class="row gutter-10 align-items-center margin-top-1 justify-content-end">
					<div class="col-12 txt-r">
						<div class="label__action justify-content-end">
							<div class="label__add js-label-add">
										<svg class="icon-svg icon-plus">
											<use xlink:href="images/sprites.svg#icon-plus"></use>
										</svg><span>Pridať kategóriu</span>
							</div>
							<div class="label__remove js-label-remove">
										<svg class="icon-svg icon-close">
											<use xlink:href="images/sprites.svg#icon-close"></use>
										</svg><span>Odobrať kategóriu</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
  `
  labelGroup.append(newLabelTemplate)
}
